var storesMap = {
    init: function( ) {

        var center = [ 23.70332, 37.9908997 ];

        var initial_latitude = Number( $( ".stores-map .marker-wrapper.active:first" ).data( "latitude" ) );
        var initial_longtitude = Number( $( ".stores-map .marker-wrapper.active:first" ).data( "longtitude" ) );

        if($( ".stores-map .marker-wrapper.active" ).length>0){
            center = ol.proj.fromLonLat([initial_longtitude, initial_latitude]);
        }else{
            center = ol.proj.fromLonLat(center);
        }
            var view =  new ol.View({
                center: center,
                zoom: 12
            });

             var map = new ol.Map({
                layers: [
                  new ol.layer.Tile({
                      source: new ol.source.OSM()
                  }),
                ],
                target: 'map',
                view:view
            });

            if($( ".stores-map .marker-wrapper.active" ).length>0){ 
                  var marker_points = [];
                 $( ".stores-map .marker-wrapper.active" ).each(function(index) {
                      var  latitude = Number($( this ).data( "latitude" ));
                      var  longtitude = Number($( this ).data( "longtitude" ));
                      var element = this;

                      var pos = ol.proj.transform([longtitude, latitude ], 'EPSG:4326', 'EPSG:3857');
                     
                      var marker = new ol.Overlay({
                         element: element,
                         position: pos,
                         positioning: 'center-center'
                     });

                      marker_points.push([longtitude, latitude ]);

                      map.addOverlay(marker);

                 });

            
                 var layerExtent =  ol.extent.boundingExtent(marker_points) ;
                  layerExtent = ol.proj.transformExtent(layerExtent, ol.proj.get('EPSG:4326'), ol.proj.get('EPSG:3857'));
                  view.fit(layerExtent, {minResolution:10,size:map.getSize(),padding:[100, 100, 100, 100]} );

             }

            setTimeout(function(){
                 map.updateSize();
            }, 500);
           
             $('.store-link-marker').click(function(){
                 var lat = $(this).data( "latitude" ), lon = $(this).data( "longtitude" );
                 map.getView().setCenter(ol.proj.transform([lon, lat], 'EPSG:4326', 'EPSG:3857'));
                 map.getView().setZoom(14);
                 scroll2element($('#map'));
                 return false;
            });


             $('.marker').click(function(){
                 $('div.ol-popup').hide();
                 $(this).parent().find('div.ol-popup').show();
                 return false;
            });

              $('.ol-popup-closer').click(function(){
                 $('div.ol-popup').hide();
                 return false;
            });
    }
}